import { Helmet } from 'react-helmet';
import Header from '../Header/Header';
import DonutPlot from '../DonutPlot/DonutPlot';
import LinePlot from '../LinePlot/LinePlot';
import Dropdown from '../Dropdown/Dropdown';
import MultiDropdown from '../MultiDropdown/MultiDropdown';
import useAPIData from '../../hooks/useAPIData';
import useSelectedSystems from '../../hooks/useSelectedSystems';
import useSelectedStatuses from '../../hooks/useSelectedStatuses';
import config from '../../config';

export default function Dashboard() {
  const [selectedSystems, handleSelectedSystemsChange] = useSelectedSystems(
    config.plots.donut.defaultSystems
  );
  const [
    selectedStatuses,
    handleSelectedStatusesChange,
    handleSelectDeselectAll
  ] = useSelectedStatuses(
    config.plots.line.defaultStatuses,
    config.plots.line.allStatuses
  );
  const completionStatusProgress = useAPIData(
    '/nld_tracker/dashboard/completion_status_progress'
  );

  const structuresData = useAPIData(
    '/nld_tracker/dashboard/structures_complete?priority_year=' +
      selectedSystems
  );
  const totalPercentStructs = (
    (structuresData?.priority_year_total / structuresData?.all_years_total) *
    100
  ).toFixed(2);

  const structuresUpdated = {
    // structuresUpdated is the data fed into donut plot
    // to prevent DonutPlot from rendering "priority_year_total" and "all_years_total",
    //   "priority_year_total" and "all_years_total" are not included,
    'NLD Updated': structuresData?.['NLD Updated'],
    'NLD Not Updated': structuresData?.['NLD Not Updated']
  };

  const completionStatusCount = useAPIData(
    '/nld_tracker/dashboard/completion_status_count?priority_year=' +
      selectedSystems
  );
  const parkingLotCount = useAPIData(
    '/nld_tracker/dashboard/parking_lot_count?priority_year=' + selectedSystems
  );
  const progressCount = useAPIData(
    '/nld_tracker/dashboard/completion_status_count?priority_year=-9999'
  );

  if (
    completionStatusCount &&
    parkingLotCount &&
    completionStatusProgress &&
    structuresUpdated &&
    progressCount
  ) {
    const displayedTotals = {
      structures: `${totalPercentStructs} % of Structures`,
      completionStatus: `${config.sumOfObjectValues(
        completionStatusCount
      )} Systems`,
      parkingLot: `${config.sumOfObjectValues(parkingLotCount)} Systems`,
      progress: config.sumOfObjectValues(progressCount)
    };

    return (
      <div className='app'>
        <Helmet>
          <title>Dashboard · NLD Refinement</title>
        </Helmet>
        <Header />
        <div className='body dashboard'>
          <div className='structures-plot'>
            <div className='plot-dropdown'>
              <Dropdown
                dropdownOptions={config.plots.donut.dropdownOptions}
                handleSelectedChange={handleSelectedSystemsChange}
                selectMessage='Select Systems'
                selectClassName='dropdown'
                defaultValue={selectedSystems}
                handleArgs={[]}
              />
            </div>
            <div className='plot-title'>
              Structures Behind Levees
              <div className='plot-subtitle'>
                ({config.plots.donut.titleByOption[selectedSystems]})
              </div>
            </div>
            <div className='plot-body'>
              <DonutPlot
                data={structuresUpdated}
                name='structures'
                isPercent={true}
                displayTotal={displayedTotals.structures}
              />
            </div>
          </div>
          <div className='status-count-plot'>
            <div className='plot-title'>
              Completion Status
              <div className='plot-subtitle'>
                ({config.plots.donut.titleByOption[selectedSystems]})
              </div>
            </div>
            <div className='plot-body'>
              <DonutPlot
                data={completionStatusCount}
                name='statuscount'
                displayTotal={displayedTotals.completionStatus}
              />
            </div>
          </div>
          <div className='parkinglot-plot'>
            <div className='plot-title'>
              Parking Lot
              <div className='plot-subtitle'>
                ({config.plots.donut.titleByOption[selectedSystems]})
              </div>
            </div>
            <div className='plot-body'>
              <DonutPlot
                data={parkingLotCount}
                name='parkinglot'
                displayTotal={displayedTotals.parkingLot}
              />
            </div>
          </div>
          <div className='status-progress-plot'>
            <div className='plot-dropdown'>
              <MultiDropdown
                dropdownOptions={config.plots.line.dropdownOptions}
                defaultChecked={selectedStatuses}
                handleSelectedChange={handleSelectedStatusesChange}
                handleSelectDeselectAll={handleSelectDeselectAll}
                selectMessage='Select Statuses to Display'
              />
            </div>
            <div className='plot-title' style={{ paddingTop: '.5em' }}>
              Cumulative Progress Over Time
              <div className='plot-subtitle'>
                {`(All ${displayedTotals.progress} Non-USACE Systems)`}
              </div>
            </div>
            <div className='plot-body'>
              <LinePlot
                data={completionStatusProgress}
                selectData={selectedStatuses}
                selectedDataKeyMap={config.plots.line.dropdownOptions}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
  return <></>;
}
